import { cn } from '../../../lib/utils'

const StarRating = ({ rating }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <svg key={i} width="11" height="11" viewBox="0 0 24 24"
        fill={i <= (rating ?? 0) ? '#f59e0b' : 'none'}
        stroke={i <= (rating ?? 0) ? '#f59e0b' : '#d1d5db'}
        strokeWidth="1.5"
      >
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      </svg>
    ))}
  </div>
)

export const RecipeCard = ({ recipe, onClick }) => (
  <button
    onClick={() => onClick?.(recipe)}
    className="text-left bg-surface rounded-xl overflow-hidden border border-border hover:border-primary/30 transition-colors"
  >
    {/* Photo */}
    <div className="w-full aspect-[4/3] bg-background overflow-hidden">
      {recipe.photo_url ? (
        <img src={recipe.photo_url} alt={recipe.title} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-text-muted">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
            <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
            <line x1="12" y1="19" x2="12" y2="22" />
          </svg>
        </div>
      )}
    </div>

    <div className="p-3">
      <h3 className="text-sm font-semibold text-text-primary leading-tight line-clamp-2">{recipe.title}</h3>

      <div className="flex items-center justify-between mt-1.5">
        {recipe.rating ? (
          <StarRating rating={recipe.rating} />
        ) : (
          <span />
        )}
        {recipe.cook_time_minutes && (
          <span className="text-[11px] text-text-muted">{recipe.cook_time_minutes} min</span>
        )}
      </div>
    </div>
  </button>
)
